import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import EnTextField from 'Components/inputs/EnTextFieldV2/EnTextFieldV2.vue';
import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnValidationErrorMessage from 'Components/feedback/EnValidationErrorMessage/EnValidationErrorMessage.vue';
import EnIcon from 'Components/icons/EnIcon.vue';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import EnWidgetCard from 'Components/widgets/EnWidgetCard/EnWidgetCard.vue';
import { required } from 'Js/validation/rules';
import { sleep } from 'Js/utils/sleep';
import { useSessionStorage } from 'Components/navigation/utils/useSessionStorage';
import { getUrlParams } from 'Js/utils/urlUtils';
import { EnButtonVariants } from 'Components/types/EnButtonVariants';
import { HelpLinks } from 'Js/constants/helpLinks';
import { useUserSettingsStore } from 'Js/store/useUserSettingsStore';
const findOutMoreUrl = 'https://www.enloc.de/zeit-sich-kennenzulernen/';
export default {
  __name: 'login',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const _storeToRefs = storeToRefs(useUserSettingsStore()),
      state = _storeToRefs.state,
      updateState = _storeToRefs.updateState;
    const route = useRoute();
    const userAccountName = ref(null);
    const loading = ref(true);
    let globalConfig = null;
    const isEnableLocalLogin = ref(null);
    const productName = ref();
    const clientId = ref(null);
    const errorList = ref([]);
    const externalProviders = ref([{
      AuthenticationScheme: 'aad',
      DisplayName: 'Microsoft'
    }]);
    const queryReturnUrl = ref(null);
    const shortAccountName = ref(null);
    const guidAccount = ref(null);
    const antiForgery = ref(null);
    const form = ref();
    const username = ref(null);
    const password = ref(null);
    const showPassword = ref(false);
    const updateRail = inject('updateRail');
    const supportSubject = ref("mailto:hilfe@enloc.de?Subject=".concat(encodeURIComponent(t('common.help.contactButtonSubject'))));
    const _useSessionStorage = useSessionStorage(),
      setIsEnTab = _useSessionStorage.setIsEnTab,
      getIsEnTab = _useSessionStorage.getIsEnTab;
    const isEnTab = computed(() => {
      return route.name === 'LoginEnTab' || getIsEnTab();
    });
    const rules = ref({
      required: [val => required(val)]
    });
    function togglePasswordVisibility() {
      showPassword.value = !showPassword.value;
    }
    function externalUrl(provider) {
      const query = new URLSearchParams({
        provider: provider.AuthenticationScheme
      });
      if (queryReturnUrl.value) {
        query.append('returnUrl', queryReturnUrl.value);
      }
      return "/External/Challenge?".concat(query);
    }
    const forgetPasswordUrl = computed(() => {
      const query = new URLSearchParams({
        ReturnUrl: queryReturnUrl.value
      });
      return "/Account/Profile/ForgotPassword?".concat(query);
    });
    // Will be used later
    const registerLink = computed(() => {
      const query = encodeURIComponent(queryReturnUrl.value);
      return "/Account/Profile/Register?returnUrl=".concat(query);
    });
    async function tryLogin() {
      loading.value = true;
      const response = await fetch("/Account/TryLogin", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          EmailOrUsername: username.value,
          Password: password.value,
          ClientId: clientId.value
        })
      });
      if (response.ok) {
        const config = await response.json();
        errorList.value = config.validationErrors;
        if (config.validationErrors.length === 0) {
          await form.value.submit();
        } else {
          loading.value = false;
        }
      }
    }
    onBeforeMount(async () => {
      var _useUserSettingsStore, _useUserSettingsStore2;
      const params = getUrlParams(window.location);
      for (const _ref2 of new URLSearchParams(window.location.search)) {
        var _ref3 = _slicedToArray(_ref2, 2);
        const key = _ref3[0];
        const value = _ref3[1];
        params[key.toLowerCase()] = value;
      }
      const returnUrl = params['returnurl'];
      const additionalParams = new URLSearchParams(returnUrl);
      const accountUrl = additionalParams.get('a');
      const guidUrl = additionalParams.get('g');
      guidAccount.value = guidUrl;
      const requestBody = {
        returnUrl: returnUrl
      };
      if (accountUrl) {
        requestBody.AccountName = accountUrl;
        requestBody.Guid = guidUrl;
      }
      const response = await fetch("/api/Configuration/GetConfigurationForUser", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (response.ok) {
        const config = await response.json();
        antiForgery.value = config.AntiForgeryToken;
        userAccountName.value = config.AccountDisplayName;
        isEnableLocalLogin.value = config.EnableLocalLogin;
        clientId.value = config.ClientId;
        productName.value = config.ProductName;
        queryReturnUrl.value = config.ReturnUrl;
        shortAccountName.value = config.ShortAccountName;
        globalConfig = {
          EngineUrl: config.EngineUrl,
          AuthUrl: config.AuthUrl,
          NotificationCallbacks: [],
          AddNotificationCallback: item => {
            var _this$globalState;
            (_this$globalState = this.globalState) === null || _this$globalState === void 0 || _this$globalState.NotificationCallbacks.push(item);
          },
          EnPowerAccountsForUser: config.EnPowerAccountsForUser,
          EnFlowUrls: config.EnFlowUrls,
          IsAuthUrl: config.IsAuthUrl,
          IsDev: config.IsDev,
          IsLocalApp: config.IsLocalApp,
          AiConnectionString: config.AiConnectionString,
          ModulePermissions: config.ModulePermissions,
          RolesText: config.RolesText,
          WidgetSettings: config.WidgetSettings
        };
      }
      await sleep(500);
      loading.value = false;
      updateState === null || updateState === void 0 || updateState(globalConfig);
      (_useUserSettingsStore = useUserSettingsStore()) === null || _useUserSettingsStore === void 0 || (_useUserSettingsStore2 = _useUserSettingsStore.updateState) === null || _useUserSettingsStore2 === void 0 || _useUserSettingsStore2.call(_useUserSettingsStore, globalConfig);
      setIsEnTab(!!isEnTab.value);
    });
    watch(isEnTab, val => {
      setIsEnTab(val);
    });
    onMounted(async () => {
      const main = document.querySelector('main');
      main.classList.add('login-page');
      updateRail === null || updateRail === void 0 || updateRail(true);
    });
    const __returned__ = {
      state,
      updateState,
      route,
      userAccountName,
      loading,
      get globalConfig() {
        return globalConfig;
      },
      set globalConfig(v) {
        globalConfig = v;
      },
      isEnableLocalLogin,
      productName,
      clientId,
      errorList,
      externalProviders,
      queryReturnUrl,
      shortAccountName,
      guidAccount,
      antiForgery,
      form,
      username,
      password,
      showPassword,
      updateRail,
      supportSubject,
      setIsEnTab,
      getIsEnTab,
      isEnTab,
      findOutMoreUrl,
      rules,
      togglePasswordVisibility,
      externalUrl,
      forgetPasswordUrl,
      registerLink,
      tryLogin,
      get useRoute() {
        return useRoute;
      },
      get storeToRefs() {
        return storeToRefs;
      },
      EnTextField,
      get EnOverlaySpinner() {
        return EnOverlaySpinner;
      },
      EnValidationErrorMessage,
      EnIcon,
      EnButton,
      EnWidgetCard,
      get required() {
        return required;
      },
      get sleep() {
        return sleep;
      },
      get useSessionStorage() {
        return useSessionStorage;
      },
      get getUrlParams() {
        return getUrlParams;
      },
      get EnButtonVariants() {
        return EnButtonVariants;
      },
      get HelpLinks() {
        return HelpLinks;
      },
      get useUserSettingsStore() {
        return useUserSettingsStore;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};